var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-avatar',{staticClass:"test-avatar",attrs:{"variant":"primary","size":_vm.size,"text":_vm.isSystem ? 'SYS' : _vm.text,"src":_vm.getImage()}})}
var staticRenderFns = []

export { render, staticRenderFns }